import React, { useState, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { Dashboard } from './components/Dashboard';
import { ReportPage } from './pages/ReportPage';
import { OccupancyReportPage } from './pages/OccupancyReportPage';
import { MedicationReviewPage } from './pages/MedicationReviewPage';
import { StaffingRatioPage } from './pages/StaffingRatioPage';
import { ReportsPage } from './pages/ReportsPage';
import { ResidentsPage } from './pages/ResidentsPage';
import { ResidentProfilePage } from './pages/ResidentProfilePage';
import { SettingsPage } from './pages/SettingsPage';
const AppContent = () => {
  const [query, setQuery] = useState('');
  const [activeView, setActiveView] = useState('overview');
  const navigate = useNavigate();
  const headerRef = useRef<{
    resetQuestion: () => void;
  } | null>(null);
  const handleQuerySubmit = (question: string) => {
    console.log('Question submitted:', question);
    setQuery(question);
    // Route to the appropriate report page based on the query
    const lowerCaseQuestion = question.toLowerCase();
    if (lowerCaseQuestion.includes('risk for falls')) {
      navigate('/report/fall-risk');
    } else if (lowerCaseQuestion.includes('occupancy trends')) {
      navigate('/report/occupancy');
    } else if (lowerCaseQuestion.includes('medication review')) {
      navigate('/report/medication-review');
    } else if (lowerCaseQuestion.includes('staff-to-resident ratios')) {
      navigate('/report/staffing-ratio');
    }
  };
  const resetAndNavigateToOverview = () => {
    setQuery('');
    setActiveView('overview');
    // Reset the question in the Header component
    if (headerRef.current) {
      headerRef.current.resetQuestion();
    }
    navigate('/');
  };
  // Update activeView when route changes
  const handleNavigate = (view: string, path: string) => {
    setActiveView(view);
    navigate(path);
  };
  return <div className="flex h-screen w-full bg-white font-['Lato',_sans-serif]" data-id="element-0">
      <Sidebar activeView={activeView} onNavigate={handleNavigate} data-id="element-1" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2">
        <Header onQuerySubmit={handleQuerySubmit} ref={headerRef} data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Dashboard activeView={activeView} query={query} data-id="element-6" />} data-id="element-5" />
          <Route path="/reports" element={<ReportsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/residents" element={<ResidentsPage data-id="element-10" />} data-id="element-9" />
          <Route path="/residents/:id" element={<ResidentProfilePage data-id="element-12" />} data-id="element-11" />
          <Route path="/settings" element={<SettingsPage data-id="element-14" />} data-id="element-13" />
          <Route path="/report/fall-risk" element={<ReportPage onBackToOverview={resetAndNavigateToOverview} data-id="element-16" />} data-id="element-15" />
          <Route path="/report/occupancy" element={<OccupancyReportPage onBackToOverview={resetAndNavigateToOverview} data-id="element-18" />} data-id="element-17" />
          <Route path="/report/medication-review" element={<MedicationReviewPage onBackToOverview={resetAndNavigateToOverview} data-id="element-20" />} data-id="element-19" />
          <Route path="/report/staffing-ratio" element={<StaffingRatioPage onBackToOverview={resetAndNavigateToOverview} data-id="element-22" />} data-id="element-21" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-24" />} data-id="element-23" />
        </Routes>
      </div>
    </div>;
};
export function App() {
  return <BrowserRouter data-id="element-25">
      <AppContent data-id="element-26" />
    </BrowserRouter>;
}